import React from 'react';
import { Content, ItemBlock, StatusIcon, Tasklist, Title, TitleSection } from './styles';
import SVGIcon from '../../assets/images/svg/SVGIcon';
import { observer } from 'mobx-react-lite';
import { rootStore } from '../../mobx/rootStore';
import { isEmpty, renderStatusIconName } from '../../helpers/common';
import TemplateTaskItem from './templateTaskItem.tsx';
import { ICON_SIZE } from '../../global/constants';

const TemplateTaskView = () => {
  const { projectStore } = rootStore;
  const { createProjectInput } = projectStore;
  const { selectedTemplate } = createProjectInput || {};
  const { filteredTasks } = selectedTemplate?.filteredProjectTemplateTasks || {};
  return (
    <>
      <Content>
        {filteredTasks?.map((item) => {
          return (
            <ItemBlock key={item?.id}>
              {!isEmpty(item?.name) && (
                <Tasklist>
                  <TitleSection>
                    <StatusIcon>
                      <SVGIcon
                        name={renderStatusIconName(item?.status || 0)}
                        width={ICON_SIZE.MD}
                        height={ICON_SIZE.MD}
                        viewBox={`0 0 ${ICON_SIZE.MD} ${ICON_SIZE.MD}`}
                      />
                    </StatusIcon>
                    <Title>{item?.name}</Title>
                  </TitleSection>
                </Tasklist>
              )}
              {item?.tasks?.map((task) => {
                return (
                  <div>
                    <TemplateTaskItem currentProject={selectedTemplate} task={task} />
                  </div>
                );
              })}
            </ItemBlock>
          );
        })}
      </Content>
    </>
  );
};

export default observer(TemplateTaskView);
